<script>
import CountryAPI from "$vueCommon/classes/API/CountryAPI.js";

export default {
    props: {
        selected: String,
        isInvalid: Boolean
    },
    emits: [
        'onSelected',
        'onPrefixTouched',
        'onPhoneTouched'
    ],
    mounted() {
        this.localSelected = this.selected;

        CountryAPI.getCountries().then(() => {
            this.countries = CountryAPI.toArray().sort((countryA, countryB) => {
                return countryA.name.localeCompare(countryB.name);
            });
            this.countries.map((country) => {
                country.label = '+' + country.phone_prefix + ' ' + country.name;
            });
        });
    },
    data() {
        return {
            localSelected: '',
            localPrefix: '',
            localPhone: '',
            countries: []
        }
    },
    methods: {
        getCss(option) {
            if (option && option.iso_code) {
                return 'flag-xs-' + option.iso_code.toLowerCase();
            }
            return '';
        },
        parseSelected() {
            if (!this.countries) {
                return;
            }

            const regex = /\+([0-9]{1,4})\.([0-9]{6,20})/gm;
            const phoneParts = regex.exec(this.selected);

            if (!phoneParts) {
                return;
            }

            this.localPhone = phoneParts[2];
            const prefix = parseInt(phoneParts[1]);
            for (const country of this.countries) {
                if (country.phone_prefix === prefix) {
                    this.localPrefix = country;
                }
            }
        },
        prefixSelected() {
            if (!this.localPrefix) {
                return;
            }
        },
        triggerOnSelectedEvent(touched) {
            this.localPhone = this.localPhone.replace(/[^0-9]/g, '');
            let fullNumber = '';

            if (this.localPrefix && this.localPhone) {
                fullNumber = `+${this.localPrefix.phone_prefix}.${this.localPhone}`;
            } else if (this.localPrefix) {
                fullNumber = `+${this.localPrefix.phone_prefix}`;
            } else if (this.localPhone) {
                fullNumber = this.localPhone;
            }

            this.$emit('onSelected', {fullNumber: fullNumber, prefix: this.localPrefix, number: this.localPhone});

            switch (touched) {
                case 'prefix':
                    this.$emit('onPrefixTouched');
                    break;
                case 'phone':
                    this.$emit('onPhoneTouched');
                    break;
            }
        }
    },
    watch: {
        'selected': function () {
            this.parseSelected();
        },
        'countries': function () {
            this.parseSelected();
        },
        'localPrefix': function (n, o) {
            this.triggerOnSelectedEvent('prefix');
        }
    }
}
</script>
<template>
    <div class="component-select-phone">
        <div class="input-group mb-3 mb-sm-0">
            <div class="input-group-text">
                <i class="fas fa-phone fa-fw"></i>
            </div>
            <div class="form-floating static" :class="{'is-active': localPrefix}">
                <vselect v-if="countries" :options="countries" v-model="localPrefix" :clearable="false" :searchable="true"
                         label="label" :placeholder="$translate('checkout.phone_prefix')"
                         :selected="prefixSelected()">
                    <template v-slot:option="option">
                        <div class="flag flag-xs" :class="[getCss(option)]"></div>
                        {{ option.label }}
                    </template>
                    <template v-slot:selected-option="option">
                        <div class="d-flex align-items-center">
                            <div class="flag flag-xs me-2" :class="[getCss(option)]"></div>
                            <div>+{{ option.phone_prefix }}</div>
                        </div>
                    </template>
                </vselect>
                <label>{{ $translate('checkout.phone_prefix') }}</label>
            </div>
        </div>
        <div class="input-group">
            <div class="input-group-text">
                <i class="fa fa-phone fa-fw"></i>
            </div>
            <div class="form-floating">
                <input type="text" id="select-phone-phone" class="form-control" :class="{'is-invalid': isInvalid}" v-model="localPhone" @focusout="triggerOnSelectedEvent('phone')"
                       @keydown.enter="triggerOnSelectedEvent('phone')" placeholder="$translate('manager-settings.enter_the_phone_number')">
                <label for="select-phone-phone">{{ $translate('checkout.phone_number') }}</label>
            </div>
        </div>
    </div>
</template>
